import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-menu__header" }
const _hoisted_2 = { class: "main-menu__buttons" }
const _hoisted_3 = { class: "main-menu__debug" }
const _hoisted_4 = { class: "completion-view__actions" }

import { ref, watch } from 'vue'
import {
  BfButton,
  BfCard,
  BfCheckbox,
  BfFlex,
  BfInputGroup,
  BfRadio,
  BfSideDrawer,
  Sizes,
  ButtonType,
  ButtonState,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { usePreferenceStore } from '@/store/preferenceStore'
import { useMqttStore } from '@/store/mqttStore'
import { useUserStore } from '@/store/userStore'
import { NModal } from 'naive-ui'
import ControllerInfo from '@/components/controls/ControllerInfo.vue'
import DebugInfo from '@/components/controls/DebugInfo.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainMenu',
  props: {
    dealerName: {}
  },
  setup(__props: any) {

const { t } = useI18n()
const i18n = useI18n()

const router = useRouter()

const preferenceStore = usePreferenceStore()
const mqttStore = useMqttStore()
const userStore = useUserStore()

const debug = ref(false)
const showModal = ref(false)
const editMode = ref(false)
const { connected } = storeToRefs(mqttStore)



const visible = ref(false)

const { hasPositioningMotors, hasXYTool, hasHeartRateMonitor } =
  storeToRefs(preferenceStore)

const language = ref(i18n.locale)

const save = () => {
  hasPositioningMotors.value = positioningMotors.value
  hasXYTool.value = xyTool.value
  hasHeartRateMonitor.value = heartRateMonitor.value

  userStore.logout()
  router.push({ name: 'start' })

  editMode.value = false
}

const cancel = () => {
  positioningMotors.value = hasPositioningMotors.value
  xyTool.value = hasXYTool.value
  heartRateMonitor.value = hasHeartRateMonitor.value

  editMode.value = false
}

const positioningMotors = ref(hasPositioningMotors.value)
const xyTool = ref(hasXYTool.value)
const heartRateMonitor = ref(hasHeartRateMonitor.value)

watch(language, (newLang) => {
  localStorage.setItem('ui-language', newLang)
})

/**
 * An array of all avialable locales is also avialable via `i18n.availableLocales`.
 * However, these are in lexical order. Client requests below order. This means that if languages
 * are added/removed in `i18n.ts`, they also have to be added/removed manually here.
 */
const availableLocales = [
  'zhs',
  'zht',
  'nl',
  'en',
  'fr',
  'de',
  'it',
  'ja',
  'pt',
  'ptb',
  'es',
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "hamburger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = !visible.value))
    }),
    _createVNode(_unref(BfSideDrawer), {
      visible: visible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
      direction: "left",
      size: _unref(Sizes).sm,
      class: "main-menu"
    }, {
      header: _withCtx(() => [
        _createVNode(_unref(BfFlex), {
          justify: "between",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.dealerName ?? _unref(t)('dealer.fallback')) + " ", 1),
            (__props.dealerName)
              ? (_openBlock(), _createBlock(_unref(BfButton), {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
            () => {
              _unref(userStore).logout()
              visible.value = false
              _unref(router).push({ name: 'start' })
            }
          )
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('dealer.logout')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(BfFlex), { direction: "column" }, {
          default: _withCtx(() => [
            _createVNode(_unref(BfCard), {
              padding: _unref(Sizes).md
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("h3", null, _toDisplayString(_unref(t)('modules.index')), 1),
                  _createElementVNode("div", _hoisted_2, [
                    (!editMode.value)
                      ? (_openBlock(), _createBlock(_unref(BfButton), {
                          key: 0,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = true)),
                          type: _unref(ButtonType).Outlined
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('common.change')), 1)
                          ]),
                          _: 1
                        }, 8, ["type"]))
                      : _createCommentVNode("", true),
                    (editMode.value)
                      ? (_openBlock(), _createBlock(_unref(BfButton), {
                          key: 1,
                          onClick: cancel,
                          type: _unref(ButtonType).Outlined
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
                          ]),
                          _: 1
                        }, 8, ["type"]))
                      : _createCommentVNode("", true),
                    (editMode.value)
                      ? (_openBlock(), _createBlock(_unref(BfButton), {
                          key: 2,
                          onClick: save
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('common.save')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_unref(BfInputGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BfCheckbox), {
                      id: "positioning",
                      modelValue: positioningMotors.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((positioningMotors).value = $event)),
                      name: "positioning",
                      label: _unref(t)('modules.positioning.index'),
                      disabled: !editMode.value
                    }, null, 8, ["modelValue", "label", "disabled"]),
                    _createVNode(_unref(BfCheckbox), {
                      id: "xyTool",
                      modelValue: xyTool.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((xyTool).value = $event)),
                      name: "xyTool",
                      disabled: !editMode.value,
                      label: _unref(t)('modules.xyTool.index')
                    }, null, 8, ["modelValue", "disabled", "label"]),
                    _createVNode(_unref(BfCheckbox), {
                      id: "heartrate",
                      modelValue: heartRateMonitor.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((heartRateMonitor).value = $event)),
                      name: "heartrate",
                      disabled: !editMode.value,
                      label: _unref(t)('modules.heartrate.index')
                    }, null, 8, ["modelValue", "disabled", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["padding"]),
            _createVNode(_unref(BfCard), {
              padding: _unref(Sizes).md
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_unref(t)('app.language.index')), 1),
                _createVNode(_unref(BfInputGroup), null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availableLocales, (lang, i) => {
                      return _createVNode(_unref(BfRadio), {
                        id: lang,
                        key: i,
                        modelValue: language.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((language).value = $event)),
                        name: lang,
                        value: lang,
                        label: _unref(t)(`app.language.${lang}`)
                      }, null, 8, ["id", "modelValue", "name", "value", "label"])
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["padding"]),
            (_unref(connected))
              ? (_openBlock(), _createBlock(_unref(BfCard), {
                  key: 0,
                  padding: _unref(Sizes).md
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(_unref(t)('app.fitbike.index')), 1),
                    _createVNode(ControllerInfo)
                  ]),
                  _: 1
                }, 8, ["padding"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          (!debug.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "main-menu__debug-button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (debug.value = true))
              }, _toDisplayString(_unref(t)('app.debug.showDebugInfo')), 1))
            : (_openBlock(), _createBlock(DebugInfo, { key: 1 }))
        ])
      ]),
      _: 1
    }, 8, ["visible", "size"]),
    _createVNode(_unref(NModal), {
      show: showModal.value,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showModal).value = $event)),
      style: {"width":"600px"},
      preset: "card",
      title: _unref(t)('app.fitbike.settings.warning.title'),
      bordered: false,
      size: "huge",
      "transform-origin": "center"
    }, {
      action: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(BfButton), {
            type: _unref(ButtonType).Outlined,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (((showModal.value = false), (editMode.value = false))))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          _createVNode(_unref(BfButton), {
            state: _unref(ButtonState).Enabled,
            type: _unref(ButtonType).Contained,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (((showModal.value = false), (editMode.value = true))))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.confirm')), 1)
            ]),
            _: 1
          }, 8, ["state", "type"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('app.fitbike.settings.warning.content')), 1)
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})